var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoRound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2525 14.8865L35.7289 31.9347C36.1367 32.7494 36.9162 33.1896 37.4789 32.9214L37.9848 32.6785C38.5424 32.4103 38.6662 31.5349 38.2636 30.7253L28.9818 12.068C28.7134 11.5265 28.2746 11.147 27.8461 11.0357L27.7893 11.0053H26.9221L26.8601 11.0357C26.3697 11.0508 25.8173 11.4607 25.5024 12.0983L22.0282 19.0866C21.6204 19.9013 21.7495 20.7767 22.307 21.0449L22.8129 21.2878C23.3704 21.556 24.1551 21.1107 24.5577 20.296L27.2525 14.8865ZM6.02002 11.319C5.45733 11.5872 5.33343 12.4627 5.73609 13.2774L15.0179 31.9347C15.3173 32.5368 15.8851 32.9366 16.3549 32.9923H16.2929H17.2222L17.2789 32.9518C17.7332 32.8708 18.2133 32.4812 18.5024 31.8992L21.9766 24.916C22.3793 24.1013 22.2554 23.2259 21.6978 22.9577L21.1868 22.7148C20.6293 22.4466 19.8498 22.8919 19.4419 23.7016L16.7524 29.111L8.27077 12.068C7.86811 11.2532 7.08345 10.813 6.52592 11.0761L6.02002 11.319Z",
    fill: "url(#paint0_linear_1491_10628)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1491_10628",
    x1: 5.49976,
    y1: 22,
    x2: 38.4998,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#0E7586"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8021,
    stopColor: "#42B48B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRound);
export default __webpack_public_path__ + "static/media/logo_round.6ef3689a61f596e6eec9e09270c93f31.svg";
export { ForwardRef as ReactComponent };